import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import Modal from 'react-responsive-modal'
import GraphDetail from './GraphDetail'
import { Query } from 'react-apollo'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  STATE_OF_CURRENT_DAY_BY_VEHICLE
} from '../query/metric'
import {
  Sparklines,
  SparklinesLine
} from 'react-sparklines'

class GraphComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openModal: false,
      data: this.getMetrics(this.props.sort_metrics)
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update data when sort_metrics prop changes (from polling)
    if (nextProps.sort_metrics !== this.props.sort_metrics) {
      this.setState({
        data: this.getMetrics(nextProps.sort_metrics)
      })
    }
  }

  onCloseModal () {
    const self = this
    self.setState({
      openModal: false
    })
  }

  onClick () {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        self.setState({
          openModal: true
        })
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  getMetrics (metrics) {
    // Get today's date at midnight (start of day)
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    let dataFuel = []
    metrics.forEach(function (element, key) {
      // Skip elements where occurred_at is before today
      if (element.occurred_at && element.value) {
        const occurredDate = new Date(element.occurred_at)
        if (occurredDate < today) {
          return // Skip this element
        }
      }

      let values = {}
      for (let tag in element) {
        if (tag === 'metadata') {
          for (let subTag in element[tag]) {
            values[subTag] = metrics[key][tag][subTag]
          }
        } else {
          values[tag] = element[tag]
        }
      }
      dataFuel.push(values)
    })
    return dataFuel
  }

  render () {
    let d = new Date()
    d.setHours(0, 0, 0, 0)
    var tankCapacity = this.state.data.length > 0 ? this.state.data[0].tank_capacity : null
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='GRAPHE'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <div style={styles.contentSparklines}>
              <Sparklines data={[5, 14, 7, 20, 17]} limit={5} height={80} margin={5}>
                <SparklinesLine style={{ strokeWidth: 3 }} color='#288CDC' />
              </Sparklines>
            </div>
          </div>
          <div style={styles.contentButton}>
            <div
              style={styles.button}
              onClick={() => this.onClick()}
            >
              AFFICHER
            </div>
          </div>
          <div>
            <Modal
              styles={bg}
              open={this.state.openModal}
              onClose={() => this.onCloseModal()}
              showCloseIcon={false}
              center
              focusTrapped={false}>
              <div>
                <GraphDetail
                  tankCapacity={tankCapacity}
                  metrics={this.state.data}
                  trbImm={this.props.trbImm}
                  trackableLabel={this.props.trackableLabel}
                  trackableName={this.props.trackableName}
                  onClose={() => this.onCloseModal()}
                  upload={() => console.log('UPLOAD GRAPH')}
                />
              </div>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}

const bg = {
  modal: {
    background: '#15191C',
    maxWidth: '1400px',
    overflowX: 'auto'
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '98px'
  },
  contentSparklines: {
    textAlign: 'center',
    height: '80px',
    marginTop: '98px',
    marginLeft: '24px',
    marginRight: '24px'
  },
  contentButton: {
    height: '48px',
    width: '100%'
  },
  button: {
    cursor: 'pointer',
    textAlign: 'center',
    paddingTop: '12px',
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '58px',
    height: '30px',
    borderRadius: '22px',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    color: '#272D31',
    backgroundColor: '#7ED321'
  }
}

export default GraphComponent
